import "../App.css";
import protobuf from "protobufjs";
import { debounce } from 'lodash';
import { createChart } from 'lightweight-charts';
import { IoSearchOutline } from "react-icons/io5";
import protoFile from "../protobuff/command.proto";
import { fetchHistoricalData } from "../config/Api";
import symbolFile from "../protobuff/symbolFedd.proto";
import React, { useEffect, useRef, useState } from 'react';

const getCurrentMinute = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

const LightWeightChart = ({ timeState }) => {

  const chartRef = useRef(null);
  const lastCandleRef = useRef(null);
  const candleSeriesRef = useRef(null);
  const chartContainerRef = useRef(null);
  const [hoveredOHLC, setHoveredOHLC] = useState(null);
  const [missingParams, setMissingParams] = useState(false);
  const [params] = useState(new URLSearchParams(window.location.search));


  useEffect(() => {
    const identifier = params.get("identifier")
    const symbol = params.get("symbol")
    const user_id = params.get("user_id")
    const mode = params.get("mode")
    const requiredParams = ["symbol", "user_id", "identifier"];
    const missing = requiredParams.some(param => !params.get(param));

    const tooltipElement = document.createElement("div");
    tooltipElement.classList.add("custom-tooltip");
    tooltipElement.style.display = "none";
    document.body.appendChild(tooltipElement);


    setMissingParams(missing);
    chartRef.current = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: chartContainerRef.current.clientHeight,
      layout: {
        textColor: mode == "dark" ? "#ffffff" : "black",
        background: { color: mode == "dark" ? "#222" : "#ffffff" },
      },
      grid: {
        vertLines: { color: mode == "dark" ? "#444" : "#f0f3fa" },
        horzLines: { color: mode == "dark" ? "#444" : "#f0f3fa" },
      },
      crossHair: {
        mode: 0,
      },
      timeScale: {
        timeVisible: true,
        secondsVisible: false,
        borderColor: mode == "dark" ? "#71649C" : "#d1d4dc",
        tickMarkFormatter: (time) => {
          const date = new Date(time * 1000);
          return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
      },
      priceScale: {
        borderColor: mode == "dark" ? "#5555550" : "red",
        textColor: mode == "dark" ? "#fffff" : "",
        fontSize: 16,
        fontFamily: 'Arial',
      },
    });

    candleSeriesRef.current = chartRef.current.addCandlestickSeries({
      upColor: "#089981",                     //green candle
      downColor: "#f44336",
      borderUpColor: "#089981",               //green candle
      borderDownColor: "#f44336",
      wickUpColor: "#089981",                //green candle
      wickDownColor: "#f44336",
      priceFormat: {
        minMove: 0.00001,
        precision: 5,
      }

    });
    const handleResize = () => {
      if (chartRef.current) {
        chartRef.current.applyOptions({
          width: chartContainerRef.current.clientWidth,
          height: chartContainerRef.current.clientHeight,
        });
      }
    };

    // Attach resize event listener
    window.addEventListener('resize', handleResize);


    fetchHistoricalData(identifier, symbol, user_id).then((data) => {
      if (data) {
        candleSeriesRef.current.setData(data);
        lastCandleRef.current = data[data.length - 1];
      } else {
        console.log("historical data not found");
      }
    });

    chartRef.current.subscribeCrosshairMove((param) => {
      if (param === undefined || param.time === undefined || param.seriesData.size === 0) {
        setHoveredOHLC(null);
        tooltipElement.style.display = "none";
        return;
      }
      const candle = param.seriesData.get(candleSeriesRef.current);
      if (candle) {
        tooltipElement.style.display = "block";
        tooltipElement.style.left = `${param.point.x}px`;
        tooltipElement.style.top = `${param.point.y}px`;
        const isoTime = new Date(candle.time * 1000).toISOString().split('.')[0];

        tooltipElement.innerHTML = `
          <strong>Open:</strong> ${candle.open.toFixed(5)}<br />
          <strong>High:</strong> ${candle.high.toFixed(5)}<br />
          <strong>Low:</strong> ${candle.low.toFixed(5)}<br />
          <strong>Close:</strong> ${candle.close.toFixed(5)}<br />
          <strong>time:</strong> ${isoTime}
        `;
      } else {
        tooltipElement.style.display = "none";
      }
      setHoveredOHLC(candle ? {
        time: candle.time,
        open: candle.open,
        high: candle.high,
        low: candle.low,
        close: candle.close,
      } : null);
    });

    function Submit(identifier, symbol, user_id) {
      let currentTime = getCurrentMinute();
      const webSockets = new WebSocket("wss://feed.videalpha.com/Broadcast");

      webSockets.onopen = function () {
        protobuf.load([protoFile, symbolFile], (err, root) => {
          if (err) {
            console.error("Error loading proto files:", err);
            return;
          }
          const SerializeData = root.lookupType("Command");
          if (identifier === "betatrader") {
            var connection_str = `${user_id}platformios-betaTrader_159753`;
            var connection_str2 = `${user_id}platformios-betaTrader_${symbol}`;

          } else if (identifier === "vide") {
            var connection_str = `${user_id}platformwebtradingpanel_159753`;
            var connection_str2 = `${user_id}platformwebtradingpanel_${symbol}`;
          } else {
            var connection_str = `${user_id}platformwebtradingpanel_159753`;
            var connection_str2 = `${user_id}platformwebtradingpanel_${symbol}`;
          }
          console.log(connection_str);
          console.log(connection_str2);

          const message = { command: connection_str };
          const commandMessage = SerializeData.create(message);
          const buffer = SerializeData.encode(commandMessage).finish();
          const message2 = { command: connection_str2 };
          const commandMessage2 = SerializeData.create(message2);
          const buffer2 = SerializeData.encode(commandMessage2).finish();

          webSockets.send(buffer);
          webSockets.send(buffer2);
          webSockets.onmessage = (event) => {
            const blob = event.data;
            blob.arrayBuffer().then((arrayBuffer) => {
              const dataUint8Array = new Uint8Array(arrayBuffer);
              try {
                const SymbolFeedMessage = root.lookupType("SymbolFeed");
                const decodedData = SymbolFeedMessage.decode(dataUint8Array);
                const { Ask } = decodedData;
                const t = getCurrentMinute();
                if (currentTime === t) {
                  const parsedTime = Math.floor(new Date(t).getTime() / 1000);
                  let newCandle = {};
                  if (!lastCandleRef.current || lastCandleRef.current.close === 0) {
                    newCandle = {
                      time: parsedTime,
                      open: Ask,
                      high: Ask,
                      low: Ask,
                      close: Ask,
                    };
                  } else {
                    newCandle = {
                      time: parsedTime,
                      open: lastCandleRef.current.open,
                      high: Math.max(lastCandleRef.current.high, Ask),
                      low: Math.min(lastCandleRef.current.low, Ask),
                      close: Ask,
                    };
                  }
                  lastCandleRef.current = newCandle;
                  candleSeriesRef.current.update(newCandle);
                } else {
                  currentTime = t;
                  const parsedTime = Math.floor(new Date(t).getTime() / 1000);
                  const newCandle = {
                    time: parsedTime,
                    open: Ask,
                    high: Ask,
                    low: Ask,
                    close: Ask,
                  };
                  lastCandleRef.current = newCandle;
                  candleSeriesRef.current.update(newCandle);
                }
              } catch (error) {
                console.error("Error decoding SymbolFeed:", error);
              }
            });
          };
        });
      };
    }
    Submit(identifier, symbol, user_id);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [params]);
  return (
    <>
      <div
        ref={chartContainerRef}
        className="flex-1 bg-black"
        style={{ position: 'absolute', top: '48px', left: 0, right: 0, bottom: 0 }}
      />
      {hoveredOHLC && (
        <p
          className="pl-4"
          style={{
            position: 'absolute',
            top: 45,
            left: 10,
            fontSize: '14px',
            zIndex: "50",
            color: hoveredOHLC.close >= hoveredOHLC.open ? '#089981' : '#f6685e'
          }}
        >
          <strong>O:</strong> {hoveredOHLC.open}
          <strong> H:</strong> {hoveredOHLC.high}
          <strong> L:</strong> {hoveredOHLC.low}
          <strong> C:</strong> {hoveredOHLC.close}
        </p>
      )}

    </>
  );
};

export default LightWeightChart;
